import { Link } from "react-router-dom";
import { LogoFull } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const NAV = [
  ["Services", "#services"],
  ["Why Us", "#why-us"],
  ["Process", "#process"],
  ["Coverage", "#coverage"],
  ["Book a Visit", "#booking"],
  ["Track a Booking", "#track"],
];

export const Footer = () => {
  const anchor = (href) => (e) => {
    e.preventDefault();
    scrollToId(href);
  };

  return (
    <footer className="border-t border-white/10 bg-[#0A0B0E]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <LogoFull />
            <p className="mt-5 max-w-sm text-sm text-slate-400 leading-relaxed">
              Property maintenance for owners and estates: electrical, plumbing,
              HVAC, carpentry, painting, cleaning, janitorial and handyman care
              across Greater Cincinnati and surrounding Tri-State communities.
            </p>
            <p className="mt-4 max-w-sm text-xs text-slate-500 leading-relaxed">
              Work is completed by qualified trade professionals, with licensed
              professionals used where required.
            </p>
          </div>
          <div>
            <h4 className="font-jbmono text-xs uppercase tracking-[0.2em] text-slate-500">Navigate</h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              {NAV.map(([label, href]) => (
                <li key={href}>
                  <a href={href} onClick={anchor(href)} className="transition-colors hover:text-white" data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-jbmono text-xs uppercase tracking-[0.2em] text-slate-500">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li>
                <a href="tel:+15137205882" className="transition-colors hover:text-white" data-testid="footer-phone-link">
                  (513) 720-5882
                </a>
              </li>
              <li>
                <a href="mailto:redstarsolutions513@gmail.com" className="transition-colors hover:text-white" data-testid="footer-email-link">
                  redstarsolutions513@gmail.com
                </a>
              </li>
              <li>Serving Greater Cincinnati & the Tri-State</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="font-jbmono text-xs uppercase tracking-[0.18em] text-slate-500">
            © 2026 Red Star Solutions • Property Maintenance
          </p>
          <Link to="/admin" className="font-jbmono text-xs uppercase tracking-[0.18em] text-slate-500 transition-colors hover:text-[#FF2A3B]" data-testid="footer-admin-link">
            Admin Access
          </Link>
        </div>
      </div>
    </footer>
  );
};
